export default __webpack_public_path__ + "static/media/semcasting-xandr-logo.27be8480.png";